import { EnumBadge } from '@mxa-argos/components/custom/enum-badge';
import { SearchItemLayout } from '@mxa-argos/modules/search/components/search-item-layout';
import type { SearchResult } from '@mxa-argos/modules/search/hooks/use-resource-search';
import { FileText } from 'lucide-react';

interface Props {
  result: SearchResult;
}

export function OrderSearchItem({ result }: Props) {
  return (
    <SearchItemLayout
      icon={FileText}
      primary={result.primary}
      secondary={
        result.secondary && <EnumBadge enumName="OrderStatus" value={result.secondary} size="sm" />
      }
      tertiary={result.tertiary}
      quaternary={result.quaternary}
    />
  );
}
